<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <h2>登录 DigitalHub</h2>
        <p>欢迎回来，请登录您的账号</p>
      </div>
      
      <el-form 
        ref="loginFormRef" 
        :model="loginForm" 
        :rules="loginRules" 
        label-position="top"
        @submit.prevent="handleLogin"
      >
        <el-form-item label="用户名" prop="user_name">
          <el-input 
            v-model="loginForm.user_name" 
            placeholder="请输入用户名" 
            prefix-icon="el-icon-message"
            autocomplete="user_name"
            @input="(val) => handleInput('user_name', val)"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="密码" prop="user_password">
          <el-input 
            v-model="loginForm.user_password" 
            type="password" 
            placeholder="请输入密码" 
            prefix-icon="el-icon-lock"
            autocomplete="current-password"
            show-password
            @input="(val) => handleInput('user_password', val)"
          ></el-input>
        </el-form-item>
        
        <div class="remember-forgot">
          <el-checkbox v-model="rememberMe">记住我</el-checkbox>
          <el-button type="text" @click="forgotPassword">忘记密码？</el-button>
        </div>
        
        <el-form-item>
          <el-button 
            type="primary" 
            native-type="submit" 
            :loading="loading" 
            class="login-button"
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
      
      <div class="login-footer">
        <p>欢迎您！</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'

export default {
  name: 'Login',
  setup() {
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    
    // 登录表单
    const loginForm = reactive({
      user_name: '',
      user_password: ''
    })
    
    // 表单验证规则
    const loginRules = {
      user_name: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      user_password: [
        { required: true, message: '请输入密码', trigger: 'blur' },
        { min: 6, message: '密码长度不能少于6个字符', trigger: 'blur' }
      ]
    }
    
    // 表单引用
    const loginFormRef = ref(null)
    
    // 记住我选项
    const rememberMe = ref(false)
    
    // 加载状态
    const loading = ref(false)
    
    // 处理登录
    const handleInput = (field, value) => {
      console.log(`Input ${field}:`, value)
      if (loginFormRef.value) {
        loginFormRef.value.validateField(field, (errorMsg) => {
          console.log(`Validation for ${field}:`, errorMsg || 'valid')
        })
      } else {
        console.warn('Form ref not available')
      }
    }

    const handleLogin = () => {
      loginFormRef.value.validate(async (valid) => {
        if (valid) {
          loading.value = true
          
          try {
            console.log('开始登录请求...', {
              user_name: loginForm.user_name,
              remember: rememberMe.value
            })
            
            const result = await store.dispatch('auth/login', {
              user_name: loginForm.user_name,
              user_password: loginForm.user_password,
              remember: rememberMe.value
            })
            
            console.log('登录请求结果:', result)
            console.log('当前认证状态:', store.getters['auth/isAuthenticated'])
            
            // 登录成功
            ElMessage.success('登录成功')
            
            // 持久化存储token
            const token = store.state.auth.token
            if (rememberMe.value) {
              localStorage.setItem('token', token)
            } else {
              sessionStorage.setItem('token', token)
            }
            console.log('Token已存储:', token)
            
            // 如果有重定向参数，则跳转到该页面，否则跳转到首页
            const redirectPath = route.query.redirect || '/'
            console.log('准备跳转到:', redirectPath)
            
            await router.push(redirectPath)
            console.log('跳转完成')
          } catch (error) {
            console.error('登录失败详情:', {
              error: error,
              response: error.response,
              message: error.message
            })
            ElMessage.error(error.response?.data?.message || '登录失败，请检查您的凭据')
          } finally {
            loading.value = false
          }
        } else {
          return false
        }
      })
    }
    
    // 忘记密码
    const forgotPassword = () => {
      router.push('/forgot-password')
    }
    
    return {
      loginForm,
      loginRules,
      loginFormRef,
      rememberMe,
      loading,
      handleLogin,
      forgotPassword,
      handleInput
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  margin-bottom: 10px;
  color: #303133;
}

.login-header p {
  color: #606266;
  font-size: 14px;
}

.remember-forgot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.login-button {
  width: 100%;
}

.login-footer {
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
  color: #606266;
}

.login-footer a {
  color: #2c75b7;
  text-decoration: none;
}
</style>